import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';

@Component({
  selector: 'app-r-con-fixed',
  templateUrl: './r-con-fixed.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RConFixedComponent),
      multi: true
    }
  ]
})
export class RConFixedComponent extends RenderComponentBase {
  static KEY = 'r-d-con-fixed';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.effective) {
      config.effective = [];
    }
  }
}
